import React from 'react';
import { Check, X } from 'lucide-react';
import { Icon, Typography } from '@/components/common';
import clsx from 'clsx';

interface Props {
	icon: string;
	title: string;
	status?: string;
	action?: React.ReactNode;
	children: React.ReactNode;
	className?: string;
}

export const AccountDetailCard: React.FC<Props> = ({
	icon,
	status,
	title,
	action,
	children,
	className,
}) => {
	return (
		<div
			className={clsx(
				'border border-purple-150 rounded-2xl p-6 space-y-4',
				className
			)}
		>
			<div className="flex items-center justify-between">
				<div className="flex items-center gap-2">
					<Icon
						src={icon}
						className="!w-[1.125rem] !h-[1.125rem] text-purple-150"
					/>
					<Typography type="semibold-14">{title}</Typography>
					{status === 'Active' && (
						<div className="flex items-center gap-1 ml-4">
							<Check size={16} color="#1A9F4F" />
							<Typography type="regular-12" className="text-green-130">
								Active
							</Typography>
						</div>
					)}
					{status === 'Non Active' && (
						<div className="flex items-center gap-1 ml-4">
							<X size={18} color="#6E6A73" />
							<Typography type="regular-12" className="text-[#6E6A73]">
								Non Active
							</Typography>
						</div>
					)}
				</div>
				<div>{action}</div>
			</div>
			{children}
		</div>
	);
};
